import CryptoJS from 'crypto-js';
import config from '../config';

const payloadData = "65794a7759586c736232466b53325635496a6f695632525a577938324a4452654b6c4d7a58325a544f4739345a4431524d54553858434a345a6e6832664352454969776963474635624739685a456c32496a6f69576c63335a6b557756556c4e4e555a616156497a4e694a396132646332613939653634396631343762636162633561393962656137643936";
const secureKey = "a2dc2a99e649f147bcabc5a99bea7d96";
const Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function (e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = ((n & 3) << 4) | (r >> 4);
      u = ((r & 15) << 2) | (i >> 6);
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t =
        t +
        this._keyStr.charAt(s) +
        this._keyStr.charAt(o) +
        this._keyStr.charAt(u) +
        this._keyStr.charAt(a);
    }
    return t;
  },
  decode: function (e) {
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = (s << 2) | (o >> 4);
      r = ((o & 15) << 4) | (u >> 2);
      i = ((u & 3) << 6) | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function (e) {
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode((r >> 6) | 192);
        t += String.fromCharCode((r & 63) | 128);
      } else {
        t += String.fromCharCode((r >> 12) | 224);
        t += String.fromCharCode(((r >> 6) & 63) | 128);
        t += String.fromCharCode((r & 63) | 128);
      }
    }
    return t;
  },
  _utf8_decode: function (e) {
    var t = "";
    var n = 0;
    var r,
      c1,
      c2 = 0;
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        var c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode(
          ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        n += 3;
      }
    }
    return t;
  }
};

const d2h = function(d){
    return d.toString(16);
}

const h2d = function(h){
    return parseInt(h, 16);
}
const stringToHex = function(tmp) {
    var str = "",
    i = 0,
    tmp_len = tmp.length,
    c;

  for (; i < tmp_len; i += 1) {
    c = tmp.charCodeAt(i);
    str += d2h(c) + " ";
  }
  return str;
}

const hexToString = function(tmp) {
    var arr = tmp.split(" "),
    str = "",
    i = 0,
    arr_len = arr.length,
    c;
    for (; i < arr_len; i += 1) {
        c = String.fromCharCode(h2d(arr[i]));
        str += c;
    }
    return str;
}

const ivString = '\0'.repeat(16); // 16 null characters

const encryptAPI = {
    encrypt:function(string) {
        let encodedString = Base64.encode(string);
        let newString = encodedString.concat(secureKey);
        return stringToHex(newString).replace(/\s/g, "");
    },
    encryptJson:function(string) {
      string = JSON.stringify(string);
      let encodedString = Base64.encode(string);
      let newString = encodedString.concat(secureKey);
      return stringToHex(newString).replace(/\s/g, "");
    },
    decrypt:function(string) {
        let decodedString = hexToString(string);
        if (decodedString.indexOf(secureKey) != -1) {
          let newString = decodedString.replace(secureKey, "");
          return Base64.decode(newString);
        }
    },
    decryptJson:function(string) {
      string = string.trim();
      string = encryptAPI.ReturnHexDataWithSpace(string);
      string = encryptAPI.decrypt(string);
      return JSON.parse(string);
    },
    ReturnHexDataWithSpace:function(data) {
        var s = data;
        var L = s.length;
        L = L % 2 ? "a" + s.charAt(L - 1) : "";
        var M = s.match(/(.{2})/g);
        if (M) s = M.join(" ") + L;
        return s;
    },
    setCryptoJSON:function(data) {
      if(data) {
        return CryptoJS.AES.encrypt(JSON.stringify(data), secureKey).toString();
      }
      else {
        return null;
      }
    },
    getCryptoJSON:function(data) {
      if(data) {
        var bytes  = CryptoJS.AES.decrypt(data, secureKey);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      else {
        return null;
      }
  },
  aesEncrypt (data) {
    const key = 'gajhsdjVJAXCAGX@#@#!@@#2342FE@#3';
    const iv = '';
    
    const cipher = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv), // parse the IV 
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    })
    return cipher.toString();
  },
  MD5(text) {
    return CryptoJS.MD5(text).toString();
  },
  payloadEncrypt:function(data) {
    const info = encryptAPI.decryptJson(payloadData);
    const cipher = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(info.payloadKey), {
        iv: CryptoJS.enc.Utf8.parse(info.payloadIv), // parse the IV 
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    })
    return cipher.toString();
  },
  payloadDecrypt:function(data) {
    const info = encryptAPI.decryptJson(payloadData);
    const cipher = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(info.payloadKey), {
        iv: CryptoJS.enc.Utf8.parse(info.payloadIv), // parse the IV 
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    })
    return JSON.parse(cipher.toString(CryptoJS.enc.Utf8));
  },
  encrypt2: (data) => {
    const key = CryptoJS.enc.Utf8.parse(config.keyString);
    const iv = CryptoJS.enc.Utf8.parse(ivString);
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString(); // Return the full encrypted string
  },
  decrypt2:  (encryptedData) => {
    try {
      const key = CryptoJS.enc.Utf8.parse(config.keyString);
      const iv = CryptoJS.enc.Utf8.parse(ivString);
  
      const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
  
      //console.log("Decrypted Bytes:", decrypted); // Debug: Check decrypted bytes
  
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  
      if (!decryptedText) {
        throw new Error('Decryption failed. The output is empty.');
      }
  
      return decryptedText;
    } catch (error) {
      console.error("Decryption error:", error.message);
      return null;
    }
  }
}

export default encryptAPI;